/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('resourceTimingTable', function() {
    return {
        scope: {
            data: '=',
        },
        restrict: 'AE',
        templateUrl: 'src/views/components/resource-timing-table.html',
    };
});
